// TODO - Type 'any' needs to be fixed.
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Box, Button, IconButton, Typography } from "@mui/material";
import Popover from "@mui/material/Popover";
import { useState } from "react";
import React from "react";

import DayDatePicker from "./day-date-picker";
import WeekDatePicker from "./week-date-picker";

interface IWeekNavigatorProps {
	handleBack: () => void;
	handleForward: () => void;
	date: string;
	handleCalendarClick: (e: any) => void;
	isWeekView: boolean;
	dateRangeText: string;
}

const WeekNavigator: React.FC<IWeekNavigatorProps> = ({
	handleBack,
	handleForward,
	date,
	handleCalendarClick,
	isWeekView,
	dateRangeText,
}) => {
	const [anchorEl, setAnchorEl] = useState(null);

	const handleClick = (event: any) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);
	const id = open ? "simple-popover" : undefined;

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "row",
				alignItems: "center",
				justifyContent: "center",
				gap: "10px",
			}}
		>
			<IconButton
				onClick={handleBack}
				sx={{
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					borderRadius: "4px",
					border: 0,
					cursor: "pointer",
					height: "36px",
					width: "36px",
					"&:hover": {
						backgroundColor: "#2F4D8B0A",
					},
				}}
			>
				<ChevronLeftIcon
					sx={{
						color: "#18253E",
					}}
				/>
			</IconButton>
			<IconButton
				sx={{
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					borderRadius: "4px",
					border: 0,
					cursor: "pointer",
					height: "36px",
					width: "36px",
					"&:hover": {
						backgroundColor: "#2F4D8B0A",
					},
				}}
				onClick={handleForward}
			>
				<ChevronRightIcon
					sx={{
						color: "#18253E",
					}}
				/>
			</IconButton>
			<Box>
				<Button
					sx={{
						textTransform: "none",
					}}
					onClick={handleClick}
				>
					<Typography
						sx={{
							fontFamily: "Roboto",
							fontWeight: 500,
							fontSize: "20px",
							lineHeight: "160%",
							letterSpacing: "0.15px",
							color: "#18253E",
						}}
					>
						{dateRangeText}
					</Typography>
				</Button>
				<Popover
					id={id}
					open={open}
					anchorEl={anchorEl}
					onClose={handleClose}
					transformOrigin={{
						horizontal: "center",
						vertical: "top",
					}}
					anchorOrigin={{
						vertical: "bottom",
						horizontal: "center",
					}}
				>
					{isWeekView ? (
						<WeekDatePicker
							anyDateOfSelectedWeek={new Date(date)}
							changeDateOfSelectedWeek={handleCalendarClick}
						/>
					) : (
						<DayDatePicker
							currentDate={new Date(date)}
							handleCalendarClick={handleCalendarClick}
						/>
					)}
				</Popover>
			</Box>
		</Box>
	);
};

export default WeekNavigator;
